import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';

/**
 * Enrollments-Tab: reine Anzeige aller Kursanmeldungen mit Payment-Status.
 * Extrahiert aus AdminPage.jsx (Iter 27 Refactoring).
 */
const EnrollmentsTab = ({ enrollments = [] }) => (
  <Card className="bg-gradient-to-br from-gray-900 to-black border-yellow-600/20" data-testid="admin-enrollments-tab">
    <CardHeader>
      <CardTitle className="text-white">Kursanmeldungen</CardTitle>
      <CardDescription className="text-gray-400">Alle Kursanmeldungen und deren Status</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="space-y-4">
        {enrollments.map((enrollment) => (
          <div
            key={enrollment._id}
            className="border border-yellow-600/20 rounded-lg p-4 bg-gray-800/50"
            data-testid={`admin-enrollment-${enrollment._id}`}
          >
            <div className="flex justify-between items-start">
              <div>
                <h3 className="text-white font-semibold">{enrollment.employee?.name || 'Unbekannt'}</h3>
                <p className="text-gray-400 text-sm">{enrollment.course?.title || 'Unbekannter Kurs'}</p>
                <p className="text-gray-500 text-xs mt-1">Firma: {enrollment.company?.name || 'Unbekannt'}</p>
              </div>
              <div className="text-right">
                <span
                  className={`text-xs px-2 py-1 rounded ${
                    enrollment.paymentStatus === 'paid'
                      ? 'bg-green-500/20 text-green-500'
                      : 'bg-yellow-500/20 text-yellow-500'
                  }`}
                >
                  {enrollment.paymentStatus === 'paid' ? 'Bezahlt' : 'Ausstehend'}
                </span>
                <p className="text-gray-500 text-xs mt-2">
                  {enrollment.enrolledAt ? new Date(enrollment.enrolledAt).toLocaleDateString('de-DE') : ''}
                </p>
                {enrollment.course?.price && (
                  <p className="text-yellow-500 font-bold text-sm mt-1">€{enrollment.course.price}</p>
                )}
              </div>
            </div>
          </div>
        ))}
        {enrollments.length === 0 && (
          <p className="text-gray-400 text-center py-8">Keine Anmeldungen vorhanden</p>
        )}
      </div>
    </CardContent>
  </Card>
);

export default EnrollmentsTab;
